import styled from 'styled-components'

export const LayoutWrapper = styled.section`
  display: grid;
`

export const LayoutMain = styled.section`
  background: #16202c;
  min-height: calc(100vh - 40px);
  width: 100%;
  display: grid;
`
